/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Border_Router_ProblemInputs */



/**
* | output |
* | --- |
* | "Issue with the gateway co-processor" |
*
* @param {Border_Router_ProblemInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const border_router_problem = /** @type {((inputs?: Border_Router_ProblemInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Border_Router_ProblemInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Issue with the gateway co-processor")
	return /** @type {LocalizedString} */ ("Problème avec le co-processeur de la Box")
});